import stableStringify from 'json-stable-stringify';

const stringify = json => {
  return stableStringify(json);
};

export default stringify;
